enum ListSortFieldEnum {
    CreatedTime = 'CREATED_TIME',
    InvestorManager = 'INVESTOR_MANAGER',
}

export default ListSortFieldEnum;